module.exports = __webpack_public_path__ + "img/nav-design-diamondscolliers.fda1235.jpg";